import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import { useState } from "react";

export default function PurchaseAccordion({ item, data, purchaseItems }) {
  const [selectedIndex, setIndex] = useState(-1);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 4, md: 6 },
        py: 3,
        background: "white",
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={1}>
        {/* Table Headers */}
        <Grid
          container
          spacing={1}
          sx={{
            borderBottom: "1px solid #1E1E1E",
            pb: 1,
          }}
        >
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{
                textAlign: "center",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Date
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              color="primary"
              sx={{
                textAlign: "center",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total
            </Typography>
          </Grid>
        </Grid>

        {/* Accordion List */}
        <Box
          sx={{
            height: "60vh",
            overflowY: "auto",
            width: "100%",
            mt: 1,
          }}
        >
          <Grid container spacing={1}>
            {purchaseItems?.map((item, idx) => (
              <Grid item xs={12} key={idx}>
                <Accordion
                  expanded={selectedIndex === idx}
                  onChange={() => setIndex(selectedIndex === idx ? -1 : idx)}
                  sx={{
                    backgroundColor:
                      selectedIndex === idx ? "#01008B" : "#E3E3FF",
                    borderRadius: "20px",
                    boxShadow: "none",
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{
                          color: selectedIndex === idx ? "white" : "black",
                        }}
                      />
                    }
                    sx={{
                      borderRadius:
                        selectedIndex === idx ? "20px 20px 0 0" : "20px",
                      backgroundColor:
                        selectedIndex === idx ? "#01008B" : "#E3E3FF",
                    }}
                  >
                    <Grid container spacing={1} alignItems="center">
                      {/* Date */}
                      <Grid item xs={6}>
                        <Typography
                          noWrap
                          sx={{
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },

                            textAlign: "center",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 500,
                            color: selectedIndex === idx ? "white" : "black",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {convertDateToCustomFormat(item?.date?.split("T")[0])}
                        </Typography>
                      </Grid>

                      {/* Total */}
                      <Grid item xs={6}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          gap={0.5}
                          sx={{ whiteSpace: "nowrap" }}
                        >
                          <CurrencyRupeeIcon
                            sx={{
                                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              
                              color: selectedIndex === idx ? "white" : "black",
                            }}
                          />
                          <Typography
                            noWrap
                            sx={{
                              fontWeight: 500,
                              color: selectedIndex === idx ? "white" : "black",
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              fontFamily: "'Montserrat', sans-serif",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {item.amount?.toFixed(2)}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </AccordionSummary>

                  {/* Accordion Details (Item Table) */}
                  <AccordionDetails
                    sx={{
                      background: "#E3E3FF",
                      p: 1,
                      borderBottomLeftRadius: "20px",
                      borderBottomRightRadius: "20px",
                    }}
                  >
                    {/* Horizontal scroll wrapper */}
                    <Box
                      sx={{
                        overflowX: "auto",
                        width: "100%",
                      }}
                    >
                      {/* Inner content must have a minWidth to trigger horizontal scroll */}
                      <Box sx={{ minWidth: "100%", width:"100%" }}>
                        {/* Table Headers */}
                        <Grid container spacing={1} sx={{ mb: 1 }}>
                          {[
                            "Item Description",
                            "Qty",
                            "Rate (₹)",
                            "Total (₹)",
                          ].map((header, i) => (
                            <Grid
                              item
                              xs={3}
                              key={i}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                color="primary"
                                sx={{
                                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                                  fontWeight: 500,
                                  textAlign: "center",
                                  fontFamily: "'Montserrat', sans-serif",
                                }}
                              >
                                {header}
                              </Typography>
                            </Grid>
                          ))}
                        </Grid>

                        {/* Table Body */}
                        {item?.purchaseDetails?.map((item2, index) => (
                          <Grid
                            container
                            key={index}
                            spacing={1}
                            sx={{
                              borderBottom: "1px solid #ccc",
                              mb: 1,
                              py: 1,
                            }}
                          >
                            {[
                              item2?.description,
                              item2?.quantity,
                              `₹ ${item2?.price?.toFixed(2)}`,
                              `₹ ${item2?.amount?.toFixed(2)}`,
                            ].map((val, j) => (
                              <Grid
                                item
                                xs={3}
                                key={j}
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                                    fontWeight: 400,
                                    textAlign: "center",
                                    fontFamily: "'Montserrat', sans-serif",
                                  }}
                                >
                                  {val}
                                </Typography>
                              </Grid>
                            ))}
                          </Grid>
                        ))}
                      </Box>
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
}
